<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="berth">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            房态图
        </div>
        <div style="padding: 20px;">

            <!-- <div>
                <el-row> 
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable  style="margin:0 10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getCheckList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div> -->

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <div :style="styleTh" >
                        <div style="padding:20px;padding-bottom:10px;font-size:18px">
                            <div style="float:left;">
                                <span class="num1">楼宇数:<span class="num2">{{buildingSum}}</span></span>
                                <span class="num1">房间数:<span class="num2">{{roomSum}}</span></span>
                                <span class="num1">床位总数:<span class="num2">{{berthSum}}</span></span>
                                <span class="num1">预约床位数:<span class="num2">{{berthStatus1}}</span></span>
                                <span class="num1">入住床位数:<span class="num2">{{berthStatus2}}</span></span>
                                <span class="num1">空置床位数:<span class="num2">{{berthStatus0}}</span></span>
                                <span class="num1">空置率：<span class="num2">{{(baiFenBi)}}%</span></span>
                            </div>
                            <div style="float:right;">
                                <el-image style="width: 20px; height: 20px;vertical-align:middle" :src="url4"></el-image> 已预约
                                <el-image style="width: 20px; height: 20px;vertical-align:middle;margin-left:10px;" :src="url5"></el-image> 已入住
                                <el-image style="width: 20px; height: 20px;vertical-align:middle;margin-left:10px;" :src="url6"></el-image> 未入住
                            </div>
                             <div style="clear:both;hegiht:0"></div>
                        </div>
                         <el-divider></el-divider>
                        <div v-for="buildingItem in list" :key="buildingItem">
                            <div style="margin:0px 20px;font-size:18px;">楼宇：{{buildingItem.name}}</div>
                            <div v-for="roomItem in buildingItem.listRoomDTO" :key="roomItem">
                                <el-card class="box-card">
                                    <div slot="header" class="clearfix">
                                        <div style="float:left;">
                                            <!-- <span>房号：</span><span style="color:#909399;margin-right:10px;">{{buildingItem.name}}-{{roomItem.number}}</span> -->
                                            <span>房号：</span><span style="color:#909399;margin-right:10px;">{{roomItem.number}}</span>
                                        </div>
                                        <div style="float:right;">
                                            <span style="color:#0c52dc;margin-right:10px;">已预约：{{getStatus(roomItem.listBerthDTO,1)}}</span>
                                            <span style="color:red;margin-right:10px;">已入住：{{getStatus(roomItem.listBerthDTO,2)}}</span>
                                            <span>床位总数：</span><span style="color:#909399;margin-right:10px;">{{roomItem.listBerthDTO.length}}</span>
                                        </div>
                                        <div style="clear:both;height:0;"></div>
                                    </div>
                                    <div class="text item" style="text-align:center;">
                                        
                                            <div style="display: inline-block;padding:0px 10px;"   v-for="berthItem in roomItem.listBerthDTO" :key="berthItem">
                                                <el-popover
                                                placement="top-start"
                                                width="300"
                                                trigger="hover"
                                                >
                                                <div>床位状态：{{getBerthStatus(berthItem.status)}}</div>
                                                <div v-if="berthItem.checkin!=null">老人姓名：{{berthItem.checkin.elderlyName}}</div>
                                                <div v-if="berthItem.checkin!=null">联系方式：{{berthItem.checkin.phone}}</div>
                                                <div v-if="berthItem.checkin!=null">性别：{{getSex(berthItem.checkin.gender)}}</div>
                                                <div v-if="berthItem.checkin!=null">年龄：{{berthItem.checkin.age}}</div>
                                                <div>床号：{{berthItem.number}}</div>
                                                <div v-if="berthItem.checkin!=null">入住开始时间：{{formatterTime(berthItem.checkin.beginTime)}}</div>
                                                <el-image slot="reference" v-if="berthItem.status==0" style="width: 50px; height: 50px;" :src="url3"></el-image>
                                                <el-image slot="reference" v-if="berthItem.status==1" style="width: 50px; height: 50px;" :src="url1"></el-image>
                                                <el-image slot="reference" v-if="berthItem.status==2" style="width: 50px; height: 50px;" :src="url2"></el-image>
                                                </el-popover> 
                                                <div style="margin-top:5px;font-weight:bold;">{{berthItem.number}}</div>
                                                
                                            </div>
                                         
                                    </div>
                                </el-card>
                            </div>
                            <div style="clear:both;hegiht:0"></div>
                        </div>
                        
                    </div>

                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                url1:require('@/assets/chuangLanDa.png'),
                url2:require('@/assets/chuangHongDa.png'),
                url3:require('@/assets/chuangHuiDa.png'),
                url4:require('@/assets/chuangLanXiao.png'),
                url5:require('@/assets/chuangHongXiao.png'),
                url6:require('@/assets/chuangHuiXiao.png'),
                elderlyName:'',
                listAll:null,
                list:this.listAll,
                buildingSum:0,
                roomSum:0,
                berthSum:0,
                totalItems: 0,
                berthStatus0:0,
                berthStatus1:0,
                berthStatus2:0,
                baiFenBi:0,
                listDTO:[],
                pageSize:20,
                currentPage:1,
                styleTh:{
                    height:'',
                    background:'#fff',
                    'overflow-y':'auto'
                },
                
            }
        },
        created(){
            this.getList();
            this.styleTh.height=this.$store.state.tableHeight+50+'px';
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getBerthStatus(value){
                if(value==0){
                    return "未入住"
                }else if(value==1){
                    return "已预约"
                }else if(value==2){
                    return "已入住"
                }else if(value==11){
                    return "已禁用"
                }else{
                    return "未知"
                }
            },
            getSex(gender){
                if(gender==0){
                    return "女"
                }else if(gender==1){
                    return "男"
                }else {
                    return "未知"
                }
            },
            formatterTime(value) {
                return value?value.replace('T',' ').slice(0,19):null
            },
            getStatus(list,num){
                let count = 0;
                for(let i=0;i<list.length;i++){
                    if(list[i].status==num){
                        count++;
                    }
                }
                return count;
            },
            //根据老人查询床位
            getCheckList(){
                if(this.elderlyName==""){
                    this.list = this.listAll;
                    return;
                }
                this.listDTO = [];
                // let listRoomDTO = [];
                // let listBerthDTO = [];
                let list = this.listAll;
                for(let i=0;i<list.length;i++){
                    let listRoom = list[i].listRoomDTO;
                    for(let j=0;j<listRoom.length;j++){
                        let listBerth = listRoom[j].listBerthDTO;
                        for(let k=0;k<listBerth.length;k++){
                            if(listBerth[k].checkin!=null && listBerth[k].checkin.elderlyName.indexOf(this.elderlyName)!=-1){
                                console.log(listBerth[k].checkin.elderlyName)
                                let berth = listBerth[k];
                                let room = listRoom[j];
                                let building = list[i];
                                this.test(berth,room,building);

                            }
                        }
                    } 
                }
            },
            test(berth,room,building){
                let aa = [];
                let bb = [];
                let cc = [];
                aa.push(berth);
                bb.push(room);
                cc.push(building);
                if(this.listDTO.length==0){
                    room.listBerthDTO=aa
                    building.listRoomDTO.push(room.listBerthDTO);
                    this.listDTO.push(building);
                }
                console.log(this.listDTO);
            },
            getList(){
                this.tableload=true
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Berth/roomStateDiagram",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.listAll = response.data.data;
                        this.list = response.data.data;
                        this.buildingSum = this.list.length;
                        //统计数量
                        for(let i=0;i<this.list.length;i++){
                           this.roomSum = this.roomSum+ this.list[i].listRoomDTO.length;
                           for(let j=0;j<this.list[i].listRoomDTO.length;j++){
                               let listBerth = this.list[i].listRoomDTO[j].listBerthDTO;
                               this.berthSum = this.berthSum+listBerth.length;
                               for(let k=0;k<listBerth.length;k++){
                                   if(listBerth[k].status==0){
                                        this.berthStatus0++;
                                    }else if(listBerth[k].status==1){
                                        this.berthStatus1++;
                                    }else if(listBerth[k].status==2){
                                        this.berthStatus2++;
                                    }
                               }
                           } 
                        }
                        this.baiFenBi = ((this.berthStatus0/this.berthSum)*100).toFixed(2);
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                const statusValue=this.statusValue
                for(var i in statusValue){
                    if(statusValue[i].val==row.status){
                        return statusValue[i].name
                    }
                }   
            },
        }
    }
</script>

<style lang="scss" scoped>
    .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
    float: left;
    margin: 20px;
  }
  .num1{
      margin-right:25px;
  }
  .num2{
      color:#409EFF;
      font-weight: bold;
      font-size: 19px;
  }
</style>
